//TODO: this should be in sync with electron version

import { ElasticClient, LogLevel } from '@/features/telemetry/client'
import {
	type CustomDimensions,
	type EventType,
	type TelemetryMetadata,
	type TelemetryAdapter,
	type TelemetryConfig,
	type ElasticClientConfig
} from '@/features/telemetry/types'

export function useElasticTelemetryAdapter(
	configOptionGetter: <T extends keyof TelemetryConfig>(key: T) => TelemetryConfig[T] | undefined,
	processType: 'renderer' | 'main',
	config: ElasticClientConfig
): TelemetryAdapter {
	let esClient: ElasticClient | undefined

	const elasticsearchUrl = configOptionGetter('ELASTICSEARCH_URL')
	const elasticsearchApiKey = configOptionGetter('ELASTICSEARCH_API_KEY')

	if (elasticsearchUrl && elasticsearchApiKey) {
		esClient = new ElasticClient({
			url: elasticsearchUrl,
			apiKey: elasticsearchApiKey,
			config
		})
	} else {
		console.warn('Missing url or api key - Elastic telemetry not initialized.')
	}

	return {
		trackEvent(type: EventType, name: string, customProperties?: CustomDimensions) {
			esClient?.sendLog(LogLevel.INFO, name, processType, type, customProperties)
		},

		trackException(exception: Error, message: string, customProperties?: CustomDimensions) {
			esClient?.sendLog(LogLevel.ERROR, message, processType, undefined, customProperties, exception)
		},

		trackPageView() {
			// Not tracked in Elastic adapter
		},

		setMetadata(metadata: TelemetryMetadata) {
			esClient?.setMetadata(metadata)
		},

		startTransaction() {
			// Not used in Elastic adapter
			return undefined
		}
	}
}
